import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import { useContext, useEffect, useState } from "react";

import Breadcrumb from "../../components/Layout/Breadcrumb";
import Button from "@material-ui/core/Button";
import { Carousel } from "react-responsive-carousel";
import { Context } from "../../utils/store";
import Fade from '@material-ui/core/Fade';
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Layout from "../../components/Layout";
import Link from "next/link";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
import Tailwind from "../../tailwind.config"
import extractData from "../../utils/extractVariablesFromTemplates";
import fetchData from "../../utils/fetch";
import fetchRequestLibrary from "../../utils/fetchRequestLibrary";
import CustomHead from '../../components/CustomHead';

SwiperCore.use([Navigation, Scrollbar]);
function getWindowWidth() {
    const { innerWidth: width, innerHeight: height } = window;
    return width;
}


export default function Emissions({
    listCarousel,
    thematiques,
    emissions,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
}) {
    const context = useContext(Context);
    const [activeRubrique, setActiveRubrique] = useState("Rubriques");

    const [windowWidth, setWindowWidth] = useState("udndefined");
    const [activeEmissions, setActiveEmissions] = useState(null)

    const [mainArticlesList, setMainArticlesList] = useState(null)

    const [searchActive,setSearchActive]= useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [filteredShows,setFilteredShows]=useState([])
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (emissions !== activeEmissions) {
        let filteredShows = [];

        emissions?.items.forEach((thematique) => {
            if (thematique.id !== 2) {
                thematique?.emissions?.forEach((emission) => {
                    if (emission.application_position) {
                        filteredShows.push(emission);
                    }
                });
            }
        });
        filteredShows.sort((a, b) => {
            let a1 = parseInt(a.application_position) ?? 0;
            let b1 = parseInt(b.application_position) ?? 0;
            if (a1 > b1) {
                return 1;
            } else if (a1 < b1) {
                return -1;
            } else {
                return 0;
            }
        });

        setMainArticlesList(filteredShows);
        setActiveEmissions(emissions)
        }   
        function handleResize() {
            setWindowWidth(getWindowWidth());
        }
        setWindowWidth(getWindowWidth());
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [emissions]);

    const handleChange = (event) => {

        let value = event.target.value;
        if(value?.length > 0 ){
            let filteredShows = [];

            setSearchActive(true);
            setSearchValue(event.target.value)
            for(let rubrique of emissions.items){
                for(let emission of rubrique.emissions){
                    if(emission.pagetitle.toLowerCase().includes(value.toLowerCase())){
                        filteredShows.push(emission)
                    }
                }
            }
            setFilteredShows(filteredShows);

        } else{
            setSearchActive(false);
        }
    };

    const handleSwiper = (swiper) => {
        let classList = swiper.el.classList;

        if (swiper.isBeginning || swiper.isEnd) {
            if (swiper.isBeginning) {
                classList.remove("swiper-end");
                classList.add("swiper-start");
            } else {
                classList.remove("swiper-start");
                classList.add("swiper-end");
            }
        } else {
            classList.remove("swiper-start", "swiper-end");
        }
    };
    const Emissions = (props) =>{
        return(
            <Swiper
                spaceBetween={50}
                slidesPerView={
                    windowWidth <= 480
                        ? 1
                        : windowWidth <= 600
                            ? 2
                            : windowWidth <= 1024
                                ? 3
                                : 4
                }
                navigation
                scrollbar={{ draggable: true }}
                onSlideChange={(swiper) =>
                    handleSwiper(swiper)
                }
                className="emissions__theme swiper-start w-full"
                slidesPerGroup={
                    windowWidth <= 480 
                        ? 1
                        : windowWidth <= 600
                            ? 2
                            : windowWidth <= 1024
                                ? 3
                                : 4
                }
                
            >
                <div className="left-mask h-158"></div>
                <div className="right-mask h-158"></div>
                {props.datas.map((e1, i) => {
                    if (
                        e1.pagetitle !== "Sujet"
                    ) {
                        let {
                            banniereEmissions,
                        } = extractData(
                            e1.template_variables,
                            "emission"
                        );
                        return (
                            <SwiperSlide
                                key={i}
                                className="cursor-pointer text-primary-white font-nsjp font-bold mr-16 emissions__theme__item"
                            >
                                <Link
                                    href={{
                                        pathname: `emissions/${e1.id}`,
                                    }}
                                >
                                    <div className="w-full">
                                        <img
                                            className="w-full h-158 object-cover rounded"
                                            src={`${process.env.SOURCE_API}${banniereEmissions}`}
                                            alt={`Image de l'emission ${e1.pagetitle}`}
                                        />
                                        <p className=" text-14 mt-8 emission-title">{`| ${e1.pagetitle}`}</p>
                                        <div className="emission-description h-158 items-center">
                                            
                                            <div className="emission-description__text w-full" dangerouslySetInnerHTML={{__html:e1.description}}>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        );
                    }
                })}
            </Swiper>
        )
    }
    return (
        <Context.Provider
            value={{
                ...context,
                thematiques,
                emissions,
                breakingNews,
                cities,
                ephemeralChannels,
                liveData,
                medias,
            }}
        >
            <Layout>
                <CustomHead title="Emissions" description="L'actualité de l'Aube en video !"  article={mainArticlesList ? mainArticlesList[0] : null} isShow={true}/>
                <div className="bg-primary-dark ">
                    <div className="flex justify-center relative">
                        <div className="w-full xl:w-default absolute top-0 z-20 pl-8 bg-primary-dark bg-opacity-50 rounded-b hover:bg-opacity-100">
                            <Breadcrumb type={"shows"} />
                        </div>
                    </div>
                    {
                        mainArticlesList &&
                        <Carousel
                        showStatus={false}
                        autoPlay={true}
                        interval={8000}
                        infiniteLoop={true}
                        emulateTouch={true}
                        swipeable={true}
                        showThumbs={false}
                        renderIndicator={(
                            onClickHandler,
                            isSelected,
                            index
                        ) => {
                            return (
                                <p
                                    onClick={onClickHandler}
                                    onKeyDown={onClickHandler}
                                    className={`${
                                        isSelected
                                            ? "bg-primary-white"
                                            : "bg-primary-white opacity-25"
                                    } w-10 h-10 rounded-full inline-block mr-8`}
                                ></p>
                            );
                        }}
                        className="bg-primary-white mb-48 shows-carousel"
                    >
                        {mainArticlesList.map((e, i) => {
                            let { banniereEmissions } = extractData(
                                e.template_variables,
                                "emission"
                            );
                            return (
                                <Link
                                    href={{
                                        pathname: `emissions/${e.id}`,
                                    }}
                                >
                                    <div
                                        key={i}
                                        className="p-12 bg-primary-white min-h-568 relative cursor-pointer shows-carousel__item"
                                    >
                                        <img
                                            className="absolute object-cover left-0 top-0 right-0 w-full h-full self-center z-0"
                                            src={`${process.env.SOURCE_API}${banniereEmissions}`}
                                            alt={`Image de l'emission ${e.pagetitle}`}
                                        />
                                        <div className="flex justify-center z-20 absolute w-full bottom-120 left-0 px-20 phone:px-30 phone:bottom-80">
                                            <div className="w-full xl:w-default my-12">
                                                <p className="shows-carousel__item-title text-48 phone:text-32">
                                                    {e.pagetitle}
                                                </p>
                                                <HTMLEllipsis
                                                    className="font-nsjp font-normal text-left text-22 phone:text-16 text-white"
                                                    unsafeHTML={e.description}
                                                    maxLine={windowWidth <= 480 ?'3' :'2'}
                                                    ellipsis="..."
                                                    basedOn="words"
                                                />
                                            </div>
                                        </div>
                                        <div className="absolute bottom-0 w-full z-10 min-h-90per flex flex-row flex-wrap bg-gradient-to-t from-primary-dark to-transparent" />
                                    </div>
                                </Link>
                            );
                        })}
                    </Carousel>
                        
                    }
                    
                    <div className="flex justify-center">
                        <div className="w-full xl:w-default relative mb-40 phone:mb-20">
                            <div className="absolute phone:relative flex flex-row right-0 items-center phone:flex-wrap phone:px-20">
                                <div className="search-bar-emission mr-8 relative phone:w-full phone:mr-0">
                                    <SearchIcon className="text-primary-white mr-16 self-center" />
                                    <form
                                        className="self-center w-full "
                                        onSubmit={async (e) => {
                                            e.preventDefault();
                                            let searchedRubrique = await fetchData(
                                                process.env.SOURCE_API +
                                                    "rest/2.0/medias/searchEmission.php",
                                                "POST",
                                                [
                                                    {
                                                        name: "search",
                                                        value: valueSearched,
                                                    },
                                                ]
                                            );
                                            setSearchedRubrique(
                                                searchedRubrique
                                            );
                                        }}
                                    >
                                        <input
                                            className="w-full text-primary-white"
                                            placeholder="Recherche"
                                            onChange={(event)=>handleChange(event)}
                                        />
                                    </form>
                                </div>
                                <div className="phone:flex phone:justify-end phone:mt-12 phone:w-full">
                                    <PopupState
                                        variant="popover"
                                        popupId="demo-popup-menu"
                                    >
                                        {(popupState) => (
                                            <React.Fragment>
                                                <Button
                                                    endIcon={
                                                        <KeyboardArrowDownIcon />
                                                    }
                                                    variant="contained"
                                                    color="primary"
                                                    style={{
                                                        backgroundColor: "white",
                                                        color: Tailwind.theme.extend.colors["dark-blue"]
                                                    }}
                                                    classes={{
                                                        root:{
                                                            borderColor: "red",
                                                        }
                                                    }}
                                                    {...bindTrigger(popupState)}
                                                    TransitionComponent={Fade}
                                                >
                                                    {activeRubrique}
                                                </Button>
                                                <Menu {...bindMenu(popupState)}>
                                                    <MenuItem
                                                        className={`py-2 px-4 block w-full whitespace-no-wrap hover:shadow-innerDropListRubrique ${
                                                            activeRubrique
                                                                ? "shadow-innerDropListRubrique"
                                                                : ""
                                                        }`}
                                                        onClick={() => {
                                                            setActiveRubrique(
                                                                "Rubriques"
                                                            );
                                                            popupState.close();
                                                        }}
                                                    >
                                                        Rubriques
                                                    </MenuItem>
                                                    {thematiques.items.map(
                                                        (e, i) => {
                                                            let isActive =
                                                                e.pagetitle ===
                                                                activeRubrique;
                                                            return (
                                                                <MenuItem
                                                                    className={`py-2 px-4 block w-full whitespace-no-wrap hover:shadow-innerDropListRubrique ${
                                                                        isActive
                                                                            ? "shadow-innerDropListRubrique"
                                                                            : ""
                                                                    }`}
                                                                    key={i}
                                                                    onClick={() => {
                                                                        setActiveRubrique(
                                                                            e.pagetitle
                                                                        );
                                                                        popupState.close();
                                                                    }}
                                                                >
                                                                    {
                                                                        e.pagetitle
                                                                    }
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Menu>
                                            </React.Fragment>
                                        )}
                                    </PopupState>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="min-h-80 flex w-full flex-wrap justify-center xl:w-default xl:mx-auto">
                        {searchActive ? 
                            <div
                                className="w-full px-30 sm:px-20 xl:px-0 mb-56"
                            >
                                <h3 className="text-primary-white text-18 mb-16 font-nsjp font-bold">
                                    {searchValue}
                                </h3>

                                <div className="w-full">
                                    {filteredShows?.length>0 ? 
                                        <Emissions datas={filteredShows}/>
                                    :
                                        <div className="text-center text-primary-grey font-bold text-20">Aucun résultat</div>
                                    }
                                </div>
                            </div>
                        :
                            emissions.items.map((e, i) => {
                                if (
                                    (activeRubrique !== "Rubriques" &&
                                        activeRubrique === e.pagetitle) ||
                                    activeRubrique === "Rubriques"
                                ) {
                                    return (
                                        <div
                                            key={i}
                                            className="w-full px-30 sm:px-20 xl:px-0 xl:w-default mb-56"
                                        >
                                            <h3 className="text-primary-white text-18 mb-16 font-nsjp font-bold">
                                                {e.pagetitle}
                                            </h3>

                                            <div className="w-full">
                                                <Emissions datas={e.emissions}/>
                                            </div>
                                        </div>
                                    );
                                }
                            })                        
                        }

                    </div>
                </div>
            </Layout>
        </Context.Provider>
    );
}

export async function getServerSideProps() {
    console.log("\ngetServerSideProps : emissions.js\n");

    const {
        thematiques,
        emissions,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
    } = await fetchRequestLibrary();

    emissions.items.shift(); // Remove first element which is not usefull

    let listCarousel = [];

    emissions.items.forEach((element) => {
        let emissions = element.emissions;
        if(emissions.length > 0){
            if (emissions[0].pagetitle === "Sujet") {
                // If first elem is not a show (a.k.a has pagetitle 'Sujet')
                listCarousel.push(emissions[1]);
            } else {
                listCarousel.push(emissions[0]);
            }            
        }

    });
    return {
        props: {
            listCarousel,
            thematiques,
            emissions,
            breakingNews,
            cities,
            ephemeralChannels,
            liveData,
            medias,
        },
    };
}
